export default "__VITE_ASSET__ea220cf1__"